import { v4 as uuid } from "uuid";

import { HttpHeaderNames } from "@touchtech/web-api-client";

import { InstoreHttpHeaderNames, LocalStorageKeys } from "@is/constants";
import { LocalStorageService, api } from "@is/services";
import { getEnvValue } from "@is/utils/env";

import { EventTrackType, EventTrackingConfig } from "./EventTracking.types";

export class EventTracking {
  private static s_instance: EventTracking;

  private _config: EventTrackingConfig;

  private constructor(config: EventTrackingConfig) {
    this._config = config;
  }

  public static initialize(config: EventTrackingConfig) {
    if (EventTracking.s_instance) {
      throw new Error("EventTracking has already been initialized");
    }

    EventTracking.s_instance = new EventTracking(config);
  }

  public static get instance() {
    if (!EventTracking.s_instance) {
      throw new Error("EventTracking has not been initialized");
    }

    return EventTracking.s_instance;
  }

  private getUrl = () => {
    return `${this._config.apiUrl}/api/tracking/instore`;
  };

  private createRequestBody(requestBody: EventTrackType) {
    api.setHeader(
      HttpHeaderNames.APPLICATION_ID,
      getEnvValue("VITE_APPLICATION_ID")
    );

    const {
      data,
      eventType,
      skipSessionId = false,
      sessionId = LocalStorageService.getItem(LocalStorageKeys.SessionId),
      storeId = LocalStorageService.getItem(LocalStorageKeys.StoreId),
      deviceId = LocalStorageService.getItem(LocalStorageKeys.DeviceId),
      createdAt = new Date().toISOString(),
    } = requestBody;

    return {
      id: uuid(),
      createdAt,
      eventName: eventType,
      data,
      deviceId,
      storeId,
      ...{ ...(skipSessionId ? {} : { sessionId }) },
    };
  }

  private canTrackEvent(): boolean {
    return !!this._config.apiUrl;
  }

  public track(requestBody: EventTrackType): void {
    if (!EventTracking.instance.canTrackEvent()) {
      return;
    }

    const url = EventTracking.instance.getUrl();
    const body = EventTracking.instance.createRequestBody(requestBody);

    const headers = new Headers();

    if (
      (typeof requestBody.skipSessionId === "boolean" &&
        !requestBody.skipSessionId) ||
      requestBody.sessionId
    ) {
      headers.set(InstoreHttpHeaderNames.SessionId, requestBody.sessionId);
    }

    api.post(url, body, headers, true).catch((err) => {
      console.log("Error while track event: ", err);
    });
  }
}
